import React from "react";
import PropTypes from "prop-types";
import { useInput, TextInput } from "react-admin";
import { Chip } from "@material-ui/core";

const CustomChipsArrayInput = ({ source, label }) => {
	const { input } = useInput({ source });
	const { value: values, onChange, onBlur } = input;
	const {
		input: { onChange: onChangeTextValue },
	} = useInput({ source: "tag" });

	const handleAddChip = (event) => {
		if (event.target.value && event.target.value.length < 3) return;
		if (event.key === "Enter" && event.target.value !== "") {
			const newValue = [...new Set([...values, event.target.value])];
			onChange(newValue);
			onChangeTextValue("");
		}
	};

	const handleDeleteChip = (chipIndex) => {
		const newValue = values.filter((_, index) => index !== chipIndex);
		onChange(newValue);
	};
	return (
		<div>
			<TextInput
				source="tag"
				label={label}
				validate={(value) => {
					if (value?.trim() && value.trim().length < 3) {
						return "Tag must be at least 3 characters";
					}
				}}
				onKeyDown={handleAddChip}
				onBlur={onBlur}
			/>
			<div>
				{Array.isArray(values) &&
					values.map((chip, index) => (
						<Chip
							key={index}
							label={chip}
							onDelete={() => handleDeleteChip(index)}
							style={{ margin: 5 }}
						/>
					))}
			</div>
		</div>
	);
};

CustomChipsArrayInput.propTypes = {
	source: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
};

export default CustomChipsArrayInput;
